export default __webpack_public_path__ + "media/images/avatars/avatar16-77f9a3535ad08bcf247856be7fd56307.png";